import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

export function useCurrency() {
  const page    = usePage()
  const setting = computed(() => page.props.app_setting || { currency_code: 'THB', locale: 'en-US', language: 'en' })

  // Money uses regional locale (e.g. th-TH digit grouping and currency placement)
  function formatMoney(cents) {
    if (cents == null) return '—'
    return new Intl.NumberFormat(setting.value.locale, {
      style:    'currency',
      currency: setting.value.currency_code,
    }).format(cents / 100)
  }

  function formatDate(dt, options = { day: 'numeric', month: 'short', year: 'numeric' }) {
    if (!dt) return '—'
    return new Date(dt).toLocaleDateString(setting.value.locale, options)
  }

  function formatDateTime(dt) {
    if (!dt) return '—'
    return new Date(dt).toLocaleString(setting.value.locale)
  }

  return { formatMoney, formatDate, formatDateTime, setting }
}
